import { publicClient, privateClient } from './client';
import { PayPal } from './PayPal';

const customPayPal = (pub: boolean) => new PayPal(pub ? publicClient : privateClient);
export default customPayPal;
